import React, { FC } from 'react';
import Modal from '../../../../shared/modal/modal';
import styles from './modal-multiple-plot-list.module.scss'
import Button from '../../../ui-kit/button/button';
import {clearAllPlots, setInitialPlot} from '../../../../services/reducers/multiple-plot';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { LandPlot } from '../../../../interfaces/card';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { useNavigate } from 'react-router-dom';
import {setPlotColors} from "../../../../services/actions/map";
import { useTranslation } from 'react-i18next';

interface ModalMultiplePlotListProps {
    onClose: () => void;
    type: 'Delete' | 'Add' | 'Clear';
}

const ModalMultiplePlotList: FC<ModalMultiplePlotListProps> = ({ onClose, type }) => {
    const dispatch = useAppDispatch();
    const dataCard = useAppSelector(state => state.filters.selectedCard);
    const navigate = useNavigate();
    const sourceUrl = useAppSelector(state => state.multiplePlotList.sourceUrl);

    const handleClickDelete = () => {
        dispatch(clearAllPlots())
        dispatch(setPlotColors())
        onClose();
    };

    const handleClickAdd = () => {
        dispatch(setInitialPlot({ plot: dataCard as LandPlot, url: window.location.href }));
        onClose();
        navigate('/multiplePlotList');
    };

    const handleClickClear = () => {
        dispatch(clearAllPlots())
        dispatch(setPlotColors())
        onClose();
        if (sourceUrl) {
            navigate(sourceUrl);
        }
    };

    const { t } = useTranslation();
    
    const modalContent = {
        Delete: {
            text: t('modalMultiplePlotList.delete.text'),
            primaryText: t('modalMultiplePlotList.delete.primaryText'),
            secondaryText: t('modalMultiplePlotList.delete.secondaryText'),
            primaryAction: onClose,
            secondaryAction: handleClickDelete,
        },
        Add: {
            text: t('modalMultiplePlotList.add.text'),
            primaryText: t('modalMultiplePlotList.add.primaryText'),
            secondaryText: t('modalMultiplePlotList.add.secondaryText'),
            primaryAction: onClose,
            secondaryAction: handleClickAdd,
        },
        Clear: {
            text: t('modalMultiplePlotList.clear.text'),
            primaryText: t('modalMultiplePlotList.clear.primaryText'),
            secondaryText: t('modalMultiplePlotList.clear.secondaryText'),
            primaryAction: onClose,
            secondaryAction: handleClickClear,
        },
    }[type];

    return (
        <Modal>
            <div className={styles.modalMultiple}>
                <span>{modalContent.text}</span>
                <div className={styles.modalBtn}>
                    <Button onClick={modalContent.primaryAction} type="primary" className={`${styles.returnBtn} ${type === 'Clear' ? styles.clearReturnBtn : ''}`}>
                        {modalContent.primaryText}
                    </Button>
                    <Button onClick={modalContent.secondaryAction} type="outline" className={`${styles.deleteBtn} ${type === 'Clear' ? styles.clearDeleteBtn : ''}`}>
                        {modalContent.secondaryText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalMultiplePlotList;
